module.exports = __webpack_public_path__ + "img/market_hero_picture.64225254.png";